import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { sec } from "@/lib/security";
import { getAdminAccessToken, getAdminApiBaseUrl } from "@/lib/adminApi";
import { performHardLogout } from "@/lib/authLogout";

const baseQueryWithRetry = async (args, api, extraOptions) => {
  const result = await fetchBaseQuery({
    baseUrl: getAdminApiBaseUrl(),
    credentials: "omit",
    prepareHeaders: async (headers) => {
      try {
        const accessToken = await getAdminAccessToken();
        headers.set("Authorization", `Bearer ${accessToken}`);
      } catch (error) {
        if (
          error?.error === "login_required" ||
          error?.error === "missing_refresh_token" ||
          error?.message?.includes("Missing Refresh Token")
        ) {
          const auth0 = sec.getAuth0Client();
          const sdkLogout =
            auth0 && typeof auth0.logout === "function"
              ? auth0.logout.bind(auth0)
              : null;
          performHardLogout(sdkLogout);
        }
        throw error;
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  })(args, api, extraOptions);

  return result;
};

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: baseQueryWithRetry,
  tagTypes: ["Trackers", "Filters", "Devices", "DeviceDetail", "Releases", "Screensavers", "ScreensaverAssignment", "Accounts", "Locations", "Artists", "Albums", "Tracks", "RecordLabels", "Genres", "Employees", "EmployeeDepartments", "EmployeeRoles", "Channel", "ChannelProgramming", "MusicUploadReviews"],
  endpoints: () => ({}),
});
